import React from 'react';
// Components
import AboutSection from './AboutSection';
import MainServicesComponent from '../services/MainServicesComponent';
import StatsComponent from '../general/StatsComponent';
import FullListOfServices from '../services/FullListOfServices';
import MainCta from '../cta/MainCta';
import TestimonialSection from '../testimonials/TestimonialSection';
import FaqComponent from '../faq/FaqComponent';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid pt-8 sm:pt-10 md:pt-16  w-full h-full'>
      <div className='grid gap-12 lg:gap-24'>
        {/* About section */}
        <AboutSection />

        {/* Services */}
        <MainServicesComponent />

        {/* Stats */}
        <StatsComponent />
      </div>

      <div>
        {/* Full list of services */}
        <FullListOfServices />

        {/* Cta */}
        <MainCta />

        {/* Faq */}
        <FaqComponent />

        {/* Testimonials  */}
        <TestimonialSection />
      </div>
    </main>
  );
}

export default HomePageMainContainer;
